// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"a18ac1f1","228":"60a1e29d","260":"5451f7ff","831":"4abb6c7c"}[chunkId] + ".chunk.js";
};